
import { getInfo } from '@Components/Grid/components/Table/formatters';
import { PureSwitch as Switch } from 'components/form/Switch';

export default function MultipleDomainsFormatter({ info }) {
  const { value: meta } = getInfo(info)

  const value = !!meta?.files

  return <Switch name="_" value={value} disabled />
}
